/* 
Enable both:
localStorage.setItem('ouster.viewer.vizDebugConfig', JSON.stringify({ showStats: true, printLog: true }))

Disable both:
localStorage.setItem('ouster.viewer.vizDebugConfig', JSON.stringify({ showStats: false, printLog: false }))

Remove override (back to defaults):
localStorage.removeItem('ouster.viewer.vizDebugConfig')

*/

const VIZ_DEBUG_CONFIG_LOCAL_STORAGE_KEY = 'ouster.viewer.vizDebugConfig';

type VizDebugConfig = {
  showStats: boolean;
  printLog: boolean;
};

export const getVizDebugConfig = (): VizDebugConfig => {
  const defaults: VizDebugConfig = {
    // showStats: process.env.NODE_ENV !== 'production',
    showStats: false,
    printLog: false,
  };

  try {
    const rawConfig = window.localStorage.getItem(
      VIZ_DEBUG_CONFIG_LOCAL_STORAGE_KEY
    );
    if (!rawConfig) return defaults;

    const parsed = JSON.parse(rawConfig) as Partial<VizDebugConfig>;

    return {
      showStats:
        typeof parsed.showStats === 'boolean'
          ? parsed.showStats
          : defaults.showStats,
      printLog:
        typeof parsed.printLog === 'boolean'
          ? parsed.printLog
          : defaults.printLog,
    };
  } catch (error) {
    console.warn(
      `Failed to parse ${VIZ_DEBUG_CONFIG_LOCAL_STORAGE_KEY} from localStorage`,
      error
    );
    return defaults;
  }
};
